// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/taf-amendment.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/taf-amendment/taf-amd-format.js';
import g1 from '../lessons/meteorology/taf-amendment/taf-amendment-minima-exception.js';
import g2 from '../lessons/meteorology/taf-amendment/taf-amendment.js';
import g3 from '../lessons/meteorology/taf-amendment/taf-awos-cancel.js';

mount([g0, g1, g2, g3]);
